import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { RouteWithSubRoutes, NotFound } from '@cordata/buffet';

import { authorizedPyInstance as axiosPy } from '~/utils';
import { PageLayout, Navbar, SideNav } from '~/components';

import Dashboard from './dashboard';

const LeftNav = () => {
  const [sideNavItems, setSideNavItems] = useState([]);

  useEffect(() => {
    axiosPy
      .get('/api/data/reference/reference-nav-item?ref_data_type=reports')
      .then(r => r.data.data)
      .then(r => r.map(rr => ({
        ...rr,
        attributes: {
          ...rr.attributes,
          route: rr.attributes.route ? `/reports./${rr.attributes.route.replace(/[.:]/g, '/')}` : null,
        },
      })))
      .then(setSideNavItems);
  }, []);

  return (
    <SideNav items={sideNavItems} />
  );
};

const Reports = ({
  routes,
  root,
}) => {
  const match = useRouteMatch();

  return (
    <PageLayout
      Header={Navbar}
      Left={<LeftNav />}
      centerMain={false}
    >
      <Switch>
        <Route
          exact
          path={match.url}
        >
          <Dashboard />
        </Route>

        {routes?.map(r => (
          <RouteWithSubRoutes
            key={r.path}
            {...r}
            path={root ? r.path : `${match.path}/${r.path}`}
          />
        ))}

        <Route render={props => <NotFound {...props} isRoute />} />
      </Switch>
    </PageLayout>
  );
};

Reports.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.shape()),
  root: PropTypes.bool,
};

Reports.defaultProps = {
  routes: undefined,
  root: false,
};

export default Reports;
